import React, { useEffect } from 'react';
import { getAppUrl } from '../utils/helpers';

const Signup = ({ location }) => {
  useEffect(() => {
    if (typeof window !== `undefined`) {
      const urlParams = location.search;

      window.location.replace(
        `${getAppUrl()}/signup${urlParams.length > 0 ? `${urlParams}` : ''}`
      );
    }
  });

  return <></>;
};

export default Signup;
